import React from 'react';
import Icon from '../../../components/AppIcon';

const ProgressIndicator = ({ steps, currentStep, completedSteps }) => {
  return (
    <div className="w-full max-w-2xl mx-auto">
      <div className="flex items-center justify-between">
        {steps.map((step, index) => (
          <div key={step.number} className="flex items-center">
            {/* Step Circle */}
            <div className="relative">
              <div className={`w-12 h-12 rounded-full flex items-center justify-center border-2 transition-all duration-300 ${
                step.number === currentStep
                  ? 'bg-primary border-primary text-white shadow-lg'
                  : step.number <= completedSteps
                  ? 'bg-primary-100 border-primary text-primary' :'bg-white border-accent-300 text-accent-400'
              }`}>
                {step.number <= completedSteps ? (
                  <Icon name="Check" size={20} />
                ) : (
                  <span className="font-semibold">{step.number}</span>
                )}
              </div>
              
              {/* Step Info */}
              <div className="absolute top-14 left-1/2 transform -translate-x-1/2 text-center whitespace-nowrap">
                <p className={`font-medium text-sm ${
                  step.number === currentStep
                    ? 'text-primary'
                    : step.number <= completedSteps
                    ? 'text-primary' :'text-accent-600'
                }`}>
                  {step.title}
                </p>
                <p className="text-xs text-text-secondary mt-1">
                  {step.description}
                </p>
              </div>
            </div>
            
            {/* Progress Line */}
            {index < steps.length - 1 && (
              <div className="flex-1 h-0.5 mx-4 relative">
                <div className="absolute inset-0 bg-accent-200 rounded-full"></div>
                <div 
                  className={`absolute inset-0 bg-primary rounded-full transition-all duration-500 ${
                    step.number < currentStep ? 'w-full' : 'w-0'
                  }`}
                ></div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProgressIndicator;